import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Breadcrumb, Card, Form, Container } from "react-bootstrap";
import "../../assets/css/Admin.css";
import { Timeline } from 'primereact/timeline';
import { Button } from "primereact/button";
import { Badge } from 'primereact/badge';
import { HiOutlineMail, HiOutlineLocationMarker } from "react-icons/hi";
import { TbPhone } from "react-icons/tb";
import { Avatar } from 'primereact/avatar';
import { InputTextarea } from "primereact/inputtextarea";

const Customerdetails = () => {

    const [showNote, setShowNote] = useState(false);
    const [note, setNote] = useState("");

    const handleSave = () => {
        console.log("Saved Note:", note);
        setShowNote(false);
        setNote("");
    };

    const events = [
        {
            date: "10/12/2025",
            content: "This customer placed order",
            order: "#1007",
            channel: "",
            time: "1:29 pm"
        },
        {
            date: "10/12/2025",
            content: "Order Confirmation email for order",
            order: "#1002",
            email: "arindam@thegraphe.com",
            time: "2:10 pm",
            viewEmail: true
        },
        {
            date: "9/12/2025",
            content: "This customer placed order",
            order: "#1002",
            channel: "Online Store (checkout #39680203732442)",
            time: "2:10 pm"
        },
        {
            date: "9/12/2025",
            content: "Online Store created this customer",
            time: "2:10 pm"
        }
    ];


    return (
    <>
        <Container className="py-5">
            {/* <Row className="mx-0 breadcrumb_part">
              <Breadcrumb>
                  <Breadcrumb.Item>Home</Breadcrumb.Item>
                  <Breadcrumb.Item active>
                    Jonathan Smith 
                  </Breadcrumb.Item>
              </Breadcrumb>
            </Row> */}
            <Row className="mx-0 customerdetails">
                <Col md={9}>
                    <Card className="mx-auto mb-3" style={{background:'#191919'}}>
                        <Card.Body className="d-flex gap-3 align-items-center">
                            <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" className="mr-2" size="xlarge" shape="circle" />
                            <div>
                                <h4>Jonathan Smith</h4>
                                <Badge severity="secondary" value="Inactive"></Badge>
                                <Badge severity="danger" value="Renewal Failed" className="ms-2"></Badge>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card className="mx-auto mb-3" style={{background:'#191919'}}>
                        <Card.Body className="p-0">
                            <ul className="usersinfo">
                                <li>
                                    <span>Premium + Plan</span>
                                    2499 INR/month
                                </li>
                                <li>
                                    <span>Credit</span>
                                    500<sup>Spent</sup> / 2499<sup>Limit</sup>
                                </li>
                                <li>
                                    <span>Next payment</span>
                                    Jan 12th, 2026
                                </li>
                                <li>
                                    <span>Total Downloads</span>
                                    5
                                </li>
                            </ul>
                        </Card.Body>
                    </Card>
                    
                    <Card className="mx-auto mb-3" style={{background:'#191919'}}>
                        <Card.Header className="border-0 mb-0">
                            <h4>Timeline</h4>
                        </Card.Header>
                        <Card.Body>
                            <div className="activity-timeline">
                                <Timeline
                                    value={events}
                                    align="left"
                                    marker={() => <span className="timeline-dot" />}
                                    content={(item) => (
                                    <div className="timeline-content">
                                        {item.date && <div className="timeline-date">{item.date}</div>}

                                        <div className="timeline-row">
                                        <div className="timeline-text">
                                            {item.content}{" "}
                                            {item.order && <strong>{item.order}</strong>}
                                            {item.channel && ` on ${item.channel}`}
                                            {item.email && ` (${item.email})`}
                                        </div>

                                        <div className="timeline-time">{item.time}</div>
                                        </div>

                                        {/* {item.viewEmail && (
                                        <Button
                                            label="View email"
                                            className="p-button-sm p-button-outlined mt-2"
                                        />
                                        )} */}
                                    </div>
                                    )}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card className="mx-auto mb-3" style={{background:'#191919'}}>
                        <Card.Header className="border-0 border-bottom">
                            <h4>Contact information</h4>
                        </Card.Header>
                        <Card.Body className="csinfodet">
                            
                            <p><span><HiOutlineMail /></span> jonathan@thegraphe.com</p>
                            <p><span><TbPhone /></span> +91 9876543210</p>
                            <p>
                                <span><HiOutlineLocationMarker /></span>
                                Godrej Genesis Building, 11th Floor, EN-34, EN Block, Sector V, Bidhannagar,
                                700105 Kolkata West Bengal
                                India
                            </p>
                            <p></p>
                        </Card.Body>
                    </Card>
                    <Card className="mx-auto mb-3" style={{ background: "#191919" }}>
                        <Card.Header className="border-0 border-bottom d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 text-white">Notes</h4>

                            {!showNote ? (
                                <Button
                                    icon="pi pi-pencil"
                                    className="p-0"
                                    style={{ fontSize: "20px", width: "fit-content" }}
                                    text
                                    tooltip="Add Note"
                                    tooltipOptions={{ position: "top" }}
                                    onClick={() => setShowNote(true)}
                                />
                            ) : (
                                <Button
                                    icon="pi pi-times"
                                    severity="danger"
                                    className="p-0"
                                    style={{ fontSize: "20px", width: "fit-content" }}
                                    text
                                    tooltip="Close"
                                    tooltipOptions={{ position: "top" }}
                                    onClick={() => setShowNote(false)}
                                />
                            )}
                        </Card.Header>

                        <Card.Body className="csinfodet d-flex flex-column justify-content-end align-items-end">
                            {showNote && (
                                <>
                                    <InputTextarea
                                        value={note}
                                        onChange={(e) => setNote(e.target.value)}
                                        rows={4}
                                        className="w-100 mb-3"
                                        placeholder="Write your note..."
                                    />

                                    <Button
                                        label="Save"
                                        severity="warning"
                                        onClick={handleSave}
                                        className="py-1"
                                        style={{ width: "fit-content" }}
                                    />
                                </>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </>
  );
};

export default Customerdetails;